async function copyToClipboard(value: string): Promise<boolean> {

	function fallbackCopyTextToClipboard(text: string)
	{
		const textArea = document.createElement("textarea");

		textArea.value = text;

		textArea.style.top = "0";

		textArea.style.left = "0";

		textArea.style.position = "fixed";

		document.body.appendChild(textArea);

		textArea.focus();

		textArea.select();

		let succeeded = false;

		try
		{
			succeeded = document.execCommand('copy');

		} catch {
			//
		}

		document.body.removeChild(textArea);

		return succeeded;
	}

	if (!navigator.clipboard)
	{
		return fallbackCopyTextToClipboard(value);
	}
	else
	{
		try {

			await navigator.clipboard.writeText(value);

			return true;

		} catch {

			return false;
		}
	}
}

export type On = {
	show?: () => void;
	hide?: () => void;
	hideAfter?: number;
};

export const defaultHideAfter = 2000;

export const copyText = async (text: string, on: On | undefined = undefined) =>
{
	const copied = await copyToClipboard(text);

	if (copied)
	{
		if (on?.show)
		{
			on.show();
		}

		if (on?.hide)
		{
			setTimeout(on.hide, on.hideAfter ?? defaultHideAfter);
		}
	}

	return copied;
};